import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getUnreadCountOptions,
  getUnreadCountQueryKey,
  getUserNotificationsOptions,
  getUserNotificationsQueryKey,
  markAllNotificationsAsReadMutation,
  markNotificationAsReadMutation,
} from '@api/generated/@tanstack/react-query.gen';

// The caller's notifications. `enabled` lets callers gate on auth.
export function useNotifications(enabled: boolean) {
  return useQuery({
    ...getUserNotificationsOptions({ query: { limit: 20 } }),
    enabled,
    staleTime: 1000 * 30,
    refetchInterval: enabled ? 1000 * 60 : false,
  });
}

export function useUnreadCount(enabled: boolean) {
  return useQuery({
    ...getUnreadCountOptions(),
    enabled,
    staleTime: 1000 * 15,
    refetchInterval: enabled ? 1000 * 30 : false,
  });
}

export function useMarkNotificationAsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    ...markNotificationAsReadMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getUserNotificationsQueryKey(),
      });
      queryClient.invalidateQueries({ queryKey: getUnreadCountQueryKey() });
    },
  });
}

export function useMarkAllNotificationsAsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    ...markAllNotificationsAsReadMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getUserNotificationsQueryKey(),
      });
      queryClient.invalidateQueries({ queryKey: getUnreadCountQueryKey() });
    },
  });
}
